import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=781341d9&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781341d9')) {
      api.createRecord('781341d9', component.options)
    } else {
      api.reload('781341d9', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=781341d9&", function () {
      api.rerender('781341d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ONb6DXVG6hpj/JS/offershelp.vue"
export default component.exports